import {
    FETCH_USER_DATA
} from '../ActionTypes'

const INITIAL_STATE = {
    profile: {}
}

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_USER_DATA:
            return { ...state, profile: action.payload }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/ProfilePage/ProfilePageReducer.js